import React, { useState } from 'react'
import AbnormalMotionGraphReports from './AbnormalMotionGraphReports'
import AbnormalMotionReportList from './AbnormalMotionReportList'
function AbnormalMotionReports() {
  const [params, setParams] = useState({});
  return (
    <>
        <AbnormalMotionGraphReports handleParams={(payload)=>{setParams(payload)}}/>
        <AbnormalMotionReportList params={params}/>
    </>
  )
}

export default AbnormalMotionReports